import React, { useState, useEffect } from 'react';
import alert_icon from 'assests/svg/alert_warn.svg';
import './index.scss';

const LeadTagsComponent = ({ leadTags = [] }) => {
  // TO BE USED IF PRICING PART OF TAGS NEEDS TO BE BOLD IN STYLE

  // const TAGS_TO_MODIFY = {
  //     CAPEX_CHARGE: 'Total CAPEX charges:',
  //     THIRD_PARTY_CHARGES: 'Third-Party Charges'
  // };

  // const [tags, setTags] = useState([]);
  // useEffect(() => {
  //     const modifiedTags = [];
  //     leadTags.forEach(item => {
  //         let innerHtml = `<div class="alert_text">${item.tagName}</div>`;
  //         if(item && item.tagName && item.tagName.includes(TAGS_TO_MODIFY.CAPEX_CHARGE)) {
  //             const [titleText, priceText] = item.tagName.split(/Total CAPEX charges:/);
  //             innerHtml = `<div class="alert_text">${titleText}<strong>${priceText}</strong></div>`;
  //         }

  //         const modifiedItem = {
  //             ...item,
  //             tagName: innerHtml
  //         }
  //         modifiedTags.push(modifiedItem);
  //     });

  //     setTags(modifiedTags)
  // }, [leadTags]);
  return (
    <div className="configure_alert">
      <ul className="configure_list">
        {leadTags &&
          leadTags.map((item) => (
            <div className="tooltip_wrap">
              <div className="tooltip_list">
                <li>
                  <span className="alert_icon">
                    <img src={alert_icon} alt="Alert" />
                  </span>
                  <div className="alert_text">{item.tagName}</div>
                  {/* <div
                                dangerouslySetInnerHTML={{__html: item.tagName}}>
                                </div> */}
                </li>
                <div className="tooltip lead_tags">
                  <div className="tooltip_content">{item.tooltip}</div>
                </div>
              </div>
            </div>
          ))}
      </ul>
    </div>
  );
};
export default LeadTagsComponent;
